import {
  ADD_ASSET_SELECTION, INVALIDATE_ASSETS_SELECTION, REMOVE_ASSET_SELECTION,
  ADD_GROUP_SELECTION, INVALIDATE_GROUPS_SELECTION, REMOVE_GROUP_SELECTION,
  ADD_COLLECTION_SELECTION, REMOVE_COLLECTION_SELECTION, INVALIDATE_COLLECTIONS_SELECTION,
  ADD_COLLECTION_SECTION_SELECTION, REMOVE_COLLECTION_SECTION_SELECTION, INVALIDATE_COLLECTION_SECTION_SELECTION,
  ADD_CONTACT_SELECTION, REMOVE_CONTACT_SELECTION, INVALIDATE_CONTACT_SELECTION,
  ADD_USER_SELECTION, REMOVE_USER_SELECTION, INVALIDATE_USER_SELECTION, 
  ADD_COLLECTION_LIST_SELECTION, REMOVE_COLLECTION_LIST_SELECTION, INVALIDATE_COLLECTION_LISTS_SELECTION,
  ADD_STREAM_SELECTION, REMOVE_STREAM_SELECTION, INVALIDATE_STREAMS_SELECTION, MOVE_ENTITY_IN_SELECTION,
  SELECT_ASSET_PAGE, REMOVE_ASSET_PAGE, INVALIDATE_SELECTED_ASSET_PAGES, REARRANGE_ASSET_PAGES
} from './actionTypes.jsx';

/**
  Assets
*/
export function selectAsset(asset){
  return {
    type: ADD_ASSET_SELECTION,
    payload: {
      asset
    }
  }
}

export function deselectAsset(item){
  return {
    type: REMOVE_ASSET_SELECTION,
    payload: item
  }
}

export function invalidateAssetSelection(){
  return {
    type: INVALIDATE_ASSETS_SELECTION,
    payload: []
  }
}

/**
  Groups
*/
export function selectGroup(group){
  return {
    type: ADD_GROUP_SELECTION,
    payload: group
  }
}

export function deselectGroup(item){
  return {
    type: REMOVE_GROUP_SELECTION,
    payload: item
  }
}

export function invalidateGroupSelection(){
  return {
    type: INVALIDATE_GROUPS_SELECTION,
    payload: []
  }
}

/**
  Collections
*/
export function selectCollection(collection){
  return {
    type: ADD_COLLECTION_SELECTION,
    payload: collection
  }
}

export function removeCollectionSelection(collection) {
  return {
    type: REMOVE_COLLECTION_SELECTION,
    payload: collection
  }
}

export function invalidateCollectionsSelection() {
  return {
    type: INVALIDATE_COLLECTIONS_SELECTION,
    payload: {}
  }
}

export function isCollectionSelected(state, collection){
  var collections = state.selection.collections;
  if(!collections || collections.length == 0){
    return false;
  }

  let index = collections.findIndex((item) => {
    return item.id == collection.id;
  })

  return index != -1;
}

/**
  Collection List
*/
export function selectCollectionList(collectionList) {
  return {
    type: ADD_COLLECTION_LIST_SELECTION,
    payload: collectionList
  }
}

export function removeCollectionListSelection(collectionList) {
  return {
    type: REMOVE_COLLECTION_LIST_SELECTION,
    payload: collectionList
  }
}

export function invalidateCollectionListsSelection() {
  return {
    type: INVALIDATE_COLLECTION_LISTS_SELECTION,
    payload: {}
  }
}

/**
  Collection sections
*/

export function selectCollectionSection(section, collection) {
  return {
    type: ADD_COLLECTION_SECTION_SELECTION,
    payload : {
      collection: collection, 
      section: section
    }
  }
}

export function removeCollectionSectionSelection(section, collection) {
  return {
    type: REMOVE_COLLECTION_SECTION_SELECTION,
    payload: {
      collection: collection,
      section: section
    }
  }
}

export function invalidateCollectionSectionSelection() {
  return {
    type: INVALIDATE_COLLECTION_SECTION_SELECTION,
    payload: {}
  }
}

export function isCollectionSectionSelected(state, collection, section) {
  var sections = state.selection.collectionSections;
  if (!sections || sections.length == 0) {
    return false;
  }

  let index = sections.findIndex((item) => {
    return item.id == section.id;
  })

  return index != -1;
}

/**
  Contacts
*/
export function selectContact(contact) {
  return {
    type: ADD_CONTACT_SELECTION,
    payload: contact
  }
}

export function deselectContact(item) {
  return {
    type: REMOVE_CONTACT_SELECTION,
    payload: item
  }
}

export function invalidateContactSelection() {
  return {
    type: INVALIDATE_CONTACT_SELECTION,
    payload: []
  }
}

/**
  Users
*/
export function selectUser(user) {
  return {
    type: ADD_USER_SELECTION,
    payload: user
  }
}

export function deselectUser(user) {
  return {
    type: REMOVE_USER_SELECTION,
    payload: user
  }
}

export function invalidateUserSelection() {
  return {
    type: INVALIDATE_USER_SELECTION,
    payload:  {}
  }
}

/**
  Streams
*/
export function selectStream(stream){
  return {
    type: ADD_STREAM_SELECTION,
    payload: stream
  }
}

export function deselectStream(item){
  return {
    type: REMOVE_STREAM_SELECTION,
    payload: item
  }
}

export function invalidateStreamSelection(){
  return {
    type: INVALIDATE_STREAMS_SELECTION,
    payload: []
  }
}

export function moveEntityInSelection(entityType, fromIndex, toIndex ){
  return {
    type: MOVE_ENTITY_IN_SELECTION,
    payload: {
      entityType,
      fromIndex,
      toIndex
    }
  }
}

/**
 * pages
 */

export function selectAssetPage(page, selectedAsset){
  return{
    type: SELECT_ASSET_PAGE,
    payload: {
      page,
      selectedAsset
    }
  }
}

export function removeAssetPage(page){
  return{
    type: REMOVE_ASSET_PAGE,
    payload: {
      page
    }
  }
}

export function invalidateSelectedAssetPages(){
  return{
    type: INVALIDATE_SELECTED_ASSET_PAGES
  }
}

export function rearrangeAssetPages(pages){
  return{
    type:  REARRANGE_ASSET_PAGES,
    payload: {
      pages
    }
  }
}